import React from 'react'
import { useLoaderData, Link } from 'react-router-dom'

export default function Careers() {

  const careers = useLoaderData()

  return (
    <div className='careers'>
      {careers.map(career => (
        <Link to={career.id.toString()} key={career.id}>
            <p>{career.title}</p>
            <p>Based in {career.location}</p>
        </Link>
      ))}
    </div>
  )
}

export const careersLoader = async () => {
    const res = await fetch('https://job-router-eta.vercel.app/careers')
    if (!res.ok){
      throw Error('Could not fetch that career')
  }
    return res.json()
}
